import { render, staticRenderFns } from "./SucceedDetails.vue?vue&type=template&id=646e992d&"
import script from "./SucceedDetails.vue?vue&type=script&lang=js&"
export * from "./SucceedDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports